import hasClass from "./hasClass";

const removeMultipleCSSClasses = (ele, cls) => {
    const multiClass = cls.split(' ');
    if (multiClass.length > 0) {
        for (let i = 0; i < multiClass.length; i++) {
            if (hasClass(ele, multiClass[i])) {
                const reg = new RegExp(`(\\s|^)${multiClass[i]}(\\s|$)`);
                ele.className = ele.className.replace(reg, ' ');
            }
        }
    }
};
export default removeMultipleCSSClasses;
